<template>
  <div class="helptoolbar-wrap hide-for-print">
    <transition name="fade">
      <div class="helptoolbar" v-if="isVisible()">
        <div class="helptoolbar__info">
          <svg width="12" height="12" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 11.32 11.32"><path class="cls-1" d="M5.66,10.82a5.16,5.16,0,1,1,5.16-5.16A5.17,5.17,0,0,1,5.66,10.82Z"/><line class="cls-1" x1="5.66" y1="4.99" x2="5.66" y2="8.58"/><circle class="cls-2" cx="5.66" cy="3.39" r="0.79"/></svg>
        </div>
        <div class="helptoolbar__content">
          {{ description }}
          <span class="helptoolbar__content__readmore" @click="openPopup()" v-if="popupContent">{{ this.$Strings('readmore') }}</span>
        </div>
        <div @click="closeToolbar()" class="helptoolbar__close">
          <svg class="helptoolbar__close__times" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9.6 9.6"><title>times_small</title><g id="Lag_2" data-name="Lag 2"><g id="Layer_1" data-name="Layer 1"><line class="cls-1" x1="0.35" y1="0.35" x2="9.25" y2="9.25"/><line class="cls-1" x1="9.25" y1="0.35" x2="0.35" y2="9.25"/></g></g></svg>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>

import _ from 'lodash'
import axios from 'axios'

import {EventBus} from '@/event-bus.js'

export default {
  name: 'helptoolbar',
  computed: {},
  data () {
    return {
      CancelToken: axios.CancelToken,
      cancel () {},
      description: false,
      popupContent: false,
      popupTitle: false
    }
  },
  watch: {
    '$route' () {
      this.openToolbar()
    }
  },
  mounted () {
    this.openToolbar()
  },
  methods: {
    openPopup () {
      EventBus.$emit('popup.open', this.popupTitle, this.popupContent)
    },

    loadData () {
      this.cancel()

      let route = this.$route.path
      let path = _.last(route.split('/'))

      if (!path) return

      axios.get(process.env.API_URL + 'helptoolbar/' + path, {
        cancelToken: new this.CancelToken((c) => { this.cancel = c })
      })
      .then((response) => {
        if (response.data && response.data[0]) {
          this.description = response.data[0].description
          this.popupContent = response.data[0].popupContent ? response.data[0].popupContent : false
          this.popupTitle = response.data[0].popupTitle ? response.data[0].popupTitle : false
        }
      })
      .catch((error) => {
        if (!axios.isCancel(error)) {
          EventBus.$emit('popup.open', this.$Strings('json_error_title'), this.$Strings('json_error_body'))
          console.log(error)
        }
      })
    },

    openToolbar () {
      this.resetText()
      if (!this.userHasSeenThis()) {
        this.loadData()
      }
    },
    closeToolbar () {
      this.setAsSeen()
      this.resetText()
    },
    resetText () {
      this.description = false
      this.popupContent = false
      this.popupTitle = false
    },
    isVisible () {
      return this.description !== false
    },
    setAsSeen () {
      if (this.userHasSeenThis()) {
        return false
      }
      let seen = this.$cookie.get('gsoid:helptoolbar')
      if (seen) { seen = JSON.parse(seen) }
      if (!seen || Object.prototype.toString.call(seen) !== '[object Array]') { seen = [] }
      seen.push({
        'route': this.$route.path,
        'seend': true
      })
      this.$cookie.set('gsoid:helptoolbar', JSON.stringify(seen), 30)
    },
    userHasSeenThis () {
      let seen = this.$cookie.get('gsoid:helptoolbar')
      if (seen) { seen = JSON.parse(seen) }
      return (seen && _.find(seen, ['route', this.$route.path]))
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~@/components/sass/shared/colors';

  .helptoolbar{
    background: $blue;
    display: flex; -js-display: flex;
    color: $white;
    font-size: 12px;
    line-height: 1;
    padding: 15px 20px;
    position: relative;
    z-index: 200;
  }

  .helptoolbar__content{
    display: block;
    flex: 1 1 auto;
    width: 100%;
  }

  .helptoolbar__content__readmore{
    cursor: pointer;
    display: inline-block;
    margin-left: 30px;
    text-decoration: underline;
  }

  .helptoolbar__close{
    flex: 1 1 12px;
    font-size: 0;
    line-height: 0;
  }

  .helptoolbar__description{
    vertical-align: middle;
  }

  .helptoolbar__close__times,
  .helptoolbar__info{
    display: inline-block;
    height: 12px;
    vertical-align: middle;
    width: 12px;
  }

  .helptoolbar__close,
  .helptoolbar__close__times{
    cursor: pointer;
  }

  .helptoolbar__close__times{
    pointer-events: none;
  }

  .helptoolbar__info{
    margin-right: 1em;
  }

  .cls-1{fill:none;stroke:#fff;stroke-miterlimit:10;}
  .cls-2{fill:#fff;}

</style>



// WEBPACK FOOTER //
// src/components/shared/misc/HelpToolbar.vue